'use client'

// src/components/bullets/patterns.ts
var LENGTH_8_PATTERN = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
var ONE_LETTER_PATTERN = /^(?=.*[a-zA-Z])/;
var ONE_NUMBER_PATTERN = /^(?=.*\d)/;
var PASSWORD_MAX_LENGTH = 32;
var isPasswordValid = (val) => {
  return val.length <= PASSWORD_MAX_LENGTH && LENGTH_8_PATTERN.test(val) && ONE_LETTER_PATTERN.test(val) && ONE_NUMBER_PATTERN.test(val);
};

export {
  LENGTH_8_PATTERN,
  ONE_LETTER_PATTERN,
  ONE_NUMBER_PATTERN,
  isPasswordValid
};
//# sourceMappingURL=chunk-SQJGLUQL.mjs.map